import { useEffect } from 'react';
import { GuestInterviewFlow } from 'modules/interviews';

/**
 * Public, Auth0-free page behind the interview emails' personal link (`/interview?t={token}`, "Still on?" adds
 * `&answer=`). Mounted OUTSIDE Auth0ProviderWithNavigate like the guest form page, and for the same reason sets
 * `Referrer-Policy: no-referrer` while mounted: the link token rides in `?t=`.
 */
export const GuestInterviewPage = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'referrer';
    meta.content = 'no-referrer';
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);

  return <GuestInterviewFlow />;
};
